import {ISectionHeaderProps} from "./SectionHeader";

export default function MobileSectionHeader(props: ISectionHeaderProps) {
    return <div className="Mobile_section_header" id={props.section.id}>
        <img className="Mobile_section_icon" src={props.section.icon}/>
        <h2>{props.section.title}</h2>
        {props.section.subtitle != null && <h3>{props.section.subtitle}</h3>}
    </div>
}